module.exports = __webpack_public_path__ + "static/media/scrollRight2.be5d3b17.png";